export default __webpack_public_path__ + "static/media/contact.891091c2.jpg";